import { PureComponent } from 'react';
import { AsyncSVG } from './AsyncSVG';
import i10n from '../../common/i10n';

export class FileAreSafe extends PureComponent {
    render() {
        return (
            <div className="row ave-row-small justify-content-center mt-5">
                <div className="col-lg-12">
                    <div className="policy-protect-wrapper">
                        <div className="policy-protect-icon">
                            <AsyncSVG className="img-fluid" src="/images/privacy_policy_protect.svg" />
                        </div>
                        <div className="policy-protect-content">
                            <div className="my-2 small">
                                <h3 className="policy-title">{i10n._VIEW_TOOL_LAYOUT_PRIVACY_MESSAGE_1}</h3>
                                <p className="mb-0">{i10n._VIEW_TOOL_LAYOUT_PRIVACY_MESSAGE_2}</p>
                                <p className="mb-0">{i10n._VIEW_TOOL_LAYOUT_PRIVACY_MESSAGE_3}</p>
                                <p className="mb-0">{i10n._VIEW_TOOL_LAYOUT_PRIVACY_MESSAGE_4}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}